export const getLoadingTextMN = () => {
  const loadingTexts = [
    "🔬 Analyzing the latest medical research...",
    "📊 Searching through scientific data...",
    "📚 Consulting evidence-based wellness sources...",
    "🌿 Gathering insights from natural remedies...",
    "🥗 Exploring trusted nutritional guidance...",
    "🧪 Reviewing peer-reviewed health studies...",
    "📝 Compiling unbiased medical information...",
    "🌱 Delving into botanical research...",
    "🔍 Scanning reliable wellness resources...",
    "🌸 Evaluating data from natural medicine archives...",
    "🌾 Sorting through verified healing methods...",
    "🍎 Checking nutritional science databases...",
    "📑 Summarizing clinical studies on wellness...",
    "🔎 Refining information from trusted health sources...",
    "🧬 Assessing the latest discoveries in natural health...",
    "📂 Filtering data for accurate medical insights...",
    "📖 Seeking the best evidence-based practices...",
    "🧠 Interpreting nutritional science for clarity...",
    "💊 Examining clinical trials on holistic health...",
    "✅ Consulting verified sources for reliable data...",
    "🌻 Uncovering well-documented natural therapies...",
    "📜 Reviewing the science behind health and nutrition...",
    "🗂 Cross-referencing studies for trusted information...",
    "📝 Collating knowledge from medical research papers...",
    "🌼 Evaluating holistic approaches from peer-reviewed sources...",
    "🌸 Gathering precise data on herbal treatments...",
    "🌿 Integrating findings from unbiased health research...",
    "🍃 Looking up data on integrative medicine...",
    "🥼 Consulting expert opinions in nutritional science...",
    "🧾 Verifying facts from trusted medical databases..."
  ];

  const randomIndex = Math.floor(Math.random() * loadingTexts.length);
  return loadingTexts[randomIndex];
};

export const getExamplePromptsMN = () => {
  const prompts = [
    {
      header: "🌿 Medicinal Plants & Herbs",
      prompt: "What are the benefits of chamomile tea?"
    },
    {
      header: "💊 Personalized Supplement Plans",
      prompt: "Can you help me create a personalized supplement plan?"
    },
    {
      header: "🧬 Create Custom Formulas",
      prompt: "Make me a 500mg Forumla for a focus capsule"
    },
    {
      header: "⚠️ Herb-Drug Interaction Warnings",
      prompt: "Will kava interact with my anxiety medication?"
    },
    {
      header: "🌙 Natural Remedies for Sleep",
      prompt: "What herbs can help me sleep better?"
    },
    {
      header: "🛡️ Immune-Boosting Herbs",
      prompt: "What herbs can strengthen my immune system?"
    },
    {
      header: "⚕️ Herb Safety with Medications",
      prompt: "Is it safe to take ashwagandha with my current medications?"
    },
    {
      header: "😌 Stress Relief Support",
      prompt: "What are the best herbs to reduce stress and anxiety?"
    },
    {
      header: "🌼 Herbal Pain Relief",
      prompt: "What herbs can help with pain relief?"
    },
    {
      header: "🍃 Digestive Health Support",
      prompt: "Which herbs are good for digestion and gut health?"
    },
    {
      header: "⚡ Energy & Stamina Boost",
      prompt: "What natural herbs can increase my energy levels?"
    },
    {
      header: "🌸 Skin Health Remedies",
      prompt: "Are there herbs that can improve my skin?"
    },
    {
      header: "🌾 Allergy Relief Herbs",
      prompt: "What herbs can help reduce allergy symptoms?"
    },
    {
      header: "🧠 Focus & Memory Support",
      prompt: "Which herbs are best for concentration and memory?"
    },
    {
      header: "❤️ Heart Health Benefits",
      prompt: "Are there herbs that can support heart health?"
    },
    {
      header: "😊 Mood Enhancement Herbs",
      prompt: "What herbs can naturally boost my mood?"
    },
    {
      header: "🦵 Herbs for Joint Health",
      prompt: "What are some natural herbs for joint pain and arthritis?"
    },
    {
      header: "🧖‍♂️ Detox & Cleanse Support",
      prompt: "Can you suggest herbs for a natural body detox?"
    }
  ];

  for (let i = prompts.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [prompts[i], prompts[j]] = [prompts[j], prompts[i]];
  }

  return prompts.slice(0, 4);
};

export const getLoadingTextSylva = () => {
  const loadingTexts = [
    "🌿 Creating a safe space for you...",
    "💬 Preparing compassionate insights...",
    "🧘 Encouraging mindfulness and peace...",
    "🌱 Listening with empathy...",
    "🌻 Gathering guidance for emotional well-being...",
    "✨ Supporting your mental health journey...",
    "❤️ Providing a non-judgmental space...",
    "☀️ Focusing on positive actions to help you...",
    "💡 Offering understanding and clarity...",
    "🌸 Cultivating a safe environment for sharing...",
    "📖 Reflecting on helpful emotional insights...",
    "🧘 Centering thoughts for peace of mind...",
    "🔍 Exploring supportive guidance for you...",
    "🌺 Bringing together compassionate resources...",
    "💗 Listening to understand and support...",
    "🧠 Offering thoughtful, personalized guidance...",
    "📝 Considering tools for emotional growth...",
    "🌞 Fostering positivity and hope...",
    "💭 Reflecting on mindful strategies...",
    "🤲 Holding space for your thoughts...",
    "🌄 Preparing a calm environment...",
    "✨ Encouraging balance and inner peace...",
    "📚 Finding insights for resilience...",
    "🕊️ Supporting your journey with understanding...",
    "🌼 Focusing on gentle guidance...",
    "🌱 Helping you find clarity in challenges...",
    "💪 Providing emotional support...",
    "🌄 Creating a moment of calm and reflection...",
    "📈 Encouraging positive mental habits...",
    "🧘 Bringing calm and focus to our conversation..."
  ];

  const randomIndex = Math.floor(Math.random() * loadingTexts.length);
  return loadingTexts[randomIndex];
};

export const getExamplePromptsSylva = () => {
  const prompts = [
    {
      header: "🧘 Mindfulness Techniques",
      prompt: "Can you teach me some basic mindfulness exercises?"
    },
    {
      header: "❤️ Self-Compassion Tips",
      prompt: "How can I practice more self-compassion?"
    },
    {
      header: "🌈 Emotional Resilience",
      prompt: "What can I do to build emotional resilience?"
    },
    {
      header: "🌙 Managing Stress & Anxiety",
      prompt: "What are some quick ways to manage anxiety in the moment?"
    },
    {
      header: "🧠 Cognitive Behavioral Techniques",
      prompt: "Can you explain how cognitive behavioral techniques work?"
    },
    {
      header: "🌼 Improving Sleep Hygiene",
      prompt: "How can I create a better bedtime routine for improved sleep?"
    },
    {
      header: "💡 Positive Affirmations",
      prompt: "Can you suggest positive affirmations for self-esteem?"
    },
    {
      header: "🕊️ Grounding Exercises",
      prompt: "What are grounding exercises to help me feel calm?"
    },
    {
      header: "🌱 Healthy Coping Mechanisms",
      prompt: "What are some healthy ways to cope with stress?"
    },
    {
      header: "📚 Mindful Journaling",
      prompt: "What prompts can I use for mindful journaling?"
    },
    {
      header: "🛌 Relaxation Techniques",
      prompt: "Can you guide me through a simple relaxation exercise?"
    },
    {
      header: "☀️ Boosting Daily Positivity",
      prompt: "How can I incorporate more positivity into my day?"
    },
    {
      header: "🌄 Reflective Questions",
      prompt: "What questions can help me reflect on my day positively?"
    },
    {
      header: "🧘 Breathwork for Calm",
      prompt: "Can you walk me through a calming breathing exercise?"
    },
    {
      header: "🗣️ Expressing Emotions",
      prompt: "How can I learn to express my emotions more effectively?"
    },
    {
      header: "🛠️ Building Confidence",
      prompt: "What are some ways to improve my self-confidence?"
    },
    {
      header: "💭 Understanding Thoughts & Emotions",
      prompt: "Can you help me understand my thought patterns better?"
    },
    {
      header: "🔄 Creating Positive Habits",
      prompt: "How can I develop habits that support mental well-being?"
    }
  ];

  for (let i = prompts.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [prompts[i], prompts[j]] = [prompts[j], prompts[i]];
  }

  return prompts.slice(0, 4);
};

export const getLoadingTextNutrigen = () => {
  const loadingTexts = [
    "🥗 Customizing nutrition plans just for you...",
    "🍎 Analyzing the latest in food science...",
    "📊 Reviewing dietary research...",
    "🌾 Exploring nutrient-rich food options...",
    "🔍 Tailoring recommendations to your goals...",
    "🥄 Preparing personalized diet tips...",
    "🧬 Examining dietary needs...",
    "📚 Compiling nutrition insights...",
    "🌱 Suggesting nutrient-dense meal ideas...",
    "📝 Reviewing recipes for optimal nutrition...",
    "🍉 Discovering foods that fuel and energize...",
    "🔬 Interpreting the science of healthy eating...",
    "🥑 Gathering the best foods for wellness...",
    "⚖️ Balancing nutrients...",
    "🍃 Checking for essential nutrients...",
    "📖 Reviewing the benefits of whole foods...",
    "🧂 Exploring nutrient combinations...",
    "🍇 Analyzing superfoods...",
    "🥕 Developing insights on nutrient absorption...",
    "💡 Offering guidance on mindful eating habits...",
    "🌿 Assessing foods for enhanced immunity...",
    "💪 Supporting fitness goals...",
    "📑 Researching optimal diets...",
    "🥬 Recommending foods that nourish the body...",
    "🔬 Evaluating plant-based options...",
    "📂 Selecting key nutrients...",
    "🍞 Investigating foods that boost energy levels...",
    "🍋 Filtering recipes to meet dietary preferences...",
    "🥗 Providing guidance for balanced meals...",
    "🍽️ Preparing meal plans to support your lifestyle..."
  ];

  const randomIndex = Math.floor(Math.random() * loadingTexts.length);
  return loadingTexts[randomIndex];
};

export const getExamplePromptsNutrigen = () => {
  const prompts = [
    {
      header: "🍎 Personalized Diet Plans",
      prompt: "Can you create a meal plan for weight loss?"
    },
    {
      header: "🥗 Nutrient-Rich Recipes",
      prompt: "What are some high-protein vegetarian recipes?"
    },
    {
      header: "🍃 Foods for Energy",
      prompt: "Which foods boost energy naturally?"
    },
    {
      header: "🧬 Support for Gut Health",
      prompt: "What foods improve gut health?"
    },
    {
      header: "🧠 Brain-Boosting Foods",
      prompt: "Which foods help with focus and memory?"
    },
    {
      header: "💪 Muscle Gain Diet Tips",
      prompt: "How can I adjust my diet for muscle growth?"
    },
    {
      header: "🌱 Immunity-Boosting Foods",
      prompt: "What are the best foods for immunity?"
    },
    {
      header: "🌾 Managing Food Sensitivities",
      prompt: "How can I plan meals without gluten?"
    },
    {
      header: "🥑 Heart Health Nutrition",
      prompt: "What foods are good for heart health?"
    },
    {
      header: "🌿 Anti-Inflammatory Foods",
      prompt: "Can you suggest anti-inflammatory foods?"
    },
    {
      header: "⚖️ Balanced Diet Tips",
      prompt: "How can I create a balanced diet?"
    },
    {
      header: "🍋 Detox & Clean Eating",
      prompt: "What foods support a natural detox?"
    },
    {
      header: "🥄 Tips for Better Digestion",
      prompt: "Which foods improve digestion?"
    },
    {
      header: "🍇 Foods to Improve Sleep",
      prompt: "What should I eat to sleep better?"
    },
    {
      header: "📅 Healthy Eating Habits",
      prompt: "How can I build healthy eating habits?"
    },
    {
      header: "🍊 Vitamin C Sources",
      prompt: "What foods are rich in vitamin C?"
    },
    {
      header: "🍞 Fiber-Rich Foods",
      prompt: "Can you list some high-fiber foods?"
    },
    {
      header: "🍒 Foods for Clear Skin",
      prompt: "What foods help with clear skin?"
    }
  ];

  for (let i = prompts.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [prompts[i], prompts[j]] = [prompts[j], prompts[i]];
  }

  return prompts.slice(0, 4);
};
